"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9247],{

/***/ 79062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  background: #eee;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      90deg,\n      transparent,\n      rgba(255, 255, 255, 0.6),\n      transparent\n    );\n    animation: ",
        " 1.5s infinite;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 10px;\n  margin-bottom: 25px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var CardSkeleton = function(param) {
    var _type = param.type, type = _type === void 0 ? "product" : _type, customStyles = param.customStyles;
    if (type === "product") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SkeletonContainer, {
            customStyles: customStyles,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImagePlaceholder, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-mb-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60px",
                            height: "27px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "40px",
                            height: "27px"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "100%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "50%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "90%",
                            height: "14px"
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (CardSkeleton);
var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject());
var ShimmerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ShimmerWrapper",
    componentId: "sc-95c11a38-0"
})(_templateObject1(), shimmer);
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SkeletonContainer",
    componentId: "sc-95c11a38-1"
})(_templateObject2(), function(props) {
    var ref;
    return ((ref = props.customStyles) === null || ref === void 0 ? void 0 : ref.width) || "100%";
});
var ImagePlaceholder = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "ImagePlaceholder",
    componentId: "sc-95c11a38-2"
})(_templateObject3());
var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "Row",
    componentId: "sc-95c11a38-3"
})(_templateObject4(), function(props) {
    return props.width;
}, function(props) {
    return props.height || "20px";
});
var RowGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RowGroup",
    componentId: "sc-95c11a38-4"
})(_templateObject5());


/***/ }),

/***/ 49247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductCardRenderer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/utils.ts
var utils = __webpack_require__(8222);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/utils.ts
var ProductListWrapper_utils = __webpack_require__(2386);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(1657);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/constants/common.ts
var common = __webpack_require__(17584);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(80058);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
// EXTERNAL MODULE: ./src/utils/eventLogger.js
var eventLogger = __webpack_require__(4134);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(86423);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(40190);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useHandleClicks.ts








function useHandleClicks() {
    var storeData = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 2), onItemClick = ref[0], getProductLink = ref[1];
    var generateLink = function(type, data) {
        switch(type){
            case "product":
                {
                    return getProductLink(data);
                }
            case "collection":
                {
                    return (0,routes.getRoute)(routes.PATH.collectionCategories(data.id), storeData === null || storeData === void 0 ? void 0 : storeData.domain);
                }
            case "category":
                {
                    var ref, ref1;
                    return (0,routes.getRoute)("".concat((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) ? routes.PATH.SHOP : routes.PATH.PRODUCT, "?cid=").concat((data === null || data === void 0 ? void 0 : data.id) || 0), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
                }
            default:
                return "";
        }
    };
    var onListItemClick = function(type, data, e, openInNewTab) {
        e.stopPropagation();
        switch(type){
            case "product":
                {
                    onItemClick(data, e, openInNewTab);
                    break;
                }
            case "collection":
                {
                    (0,eventLogger/* default */.Z)(common/* EVENT_NAMES.COLLECTION_WIDGET_CARD_CLICK */.Kg.COLLECTION_WIDGET_CARD_CLICK, {
                        collectionId: data.id
                    }, true);
                    var link = (0,routes.getRoute)(routes.PATH.collectionCategories(data.id), storeData === null || storeData === void 0 ? void 0 : storeData.domain);
                    !openInNewTab ? router_default().push(link) : window.open(link, "_blank");
                    break;
                }
            case "category":
                {
                    var ref, ref1;
                    var redirectUrl = (0,routes.getRoute)("".concat((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) ? routes.PATH.SHOP : routes.PATH.PRODUCT, "?cid=").concat((data === null || data === void 0 ? void 0 : data.id) || 0), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
                    if (openInNewTab) {
                        window.open(redirectUrl, "_blank");
                    } else {
                        router_default().push(redirectUrl, undefined, {
                            shallow: true
                        });
                    }
                    break;
                }
        }
    };
    return {
        onListItemClick: onListItemClick,
        generateLink: generateLink
    };
}

// EXTERNAL MODULE: ./src/components/DesignSystem/Card/CardSkeleton.tsx
var CardSkeleton = __webpack_require__(79062);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductCardRenderer/SkeletonRenderer.tsx



function RenderCardSkeleton(param) {
    var _numberOfSkeletons = param.numberOfSkeletons, numberOfSkeletons = _numberOfSkeletons === void 0 ? 4 : _numberOfSkeletons;
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var oneGridCellGeometry = getConfigsAndUtils().generalValues.oneGridCellGeometry;
    if (!Number.isFinite(numberOfSkeletons) || numberOfSkeletons < 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Array.from({
            length: numberOfSkeletons
        }).map(function(_, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CardSkeleton/* default */.Z, {
                customStyles: {
                    width: "".concat(oneGridCellGeometry.width, "px"),
                    height: "".concat((ref = oneGridCellGeometry.height) === null || ref === void 0 ? void 0 : ref.toFixed(2), "px")
                }
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductCardRenderer/useLastElementObservable.ts


function useLastElementObservable() {
    var ref = (0,react.useState)(false), showAllItemsRendered = ref[0], setShowAllItemsRendered = ref[1];
    var lastItemRef = (0,react.useRef)(null);
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var _state = data.state, itemCountTotal = _state.itemCountTotal, iterableList = _state.iterableList;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, numItemsToShow = _generalValues.numItemsToShow, viewAllItemsConfig = _generalValues.viewAllItemsConfig, containerTracks = _generalValues.containerTracks;
    // This is total number of items to show finally
    var realCountToShow = (viewAllItemsConfig === null || viewAllItemsConfig === void 0 ? void 0 : viewAllItemsConfig.areAllItemsVisible) ? itemCountTotal : numItemsToShow;
    // This is initial number of items to show, when user hasn't reached the end of the list
    var virtualizedCount = (containerTracks.numColumns || 0) + 2;
    var totalItemCountToRender = showAllItemsRendered ? realCountToShow : virtualizedCount;
    var listToRender = iterableList === null || iterableList === void 0 ? void 0 : iterableList.slice(0, totalItemCountToRender);
    (0,react.useEffect)(function() {
        if (lastItemRef.current) {
            var observer = new IntersectionObserver(function(entries) {
                if (entries[0].isIntersecting) {
                    setShowAllItemsRendered(true);
                    if (lastItemRef.current) observer.unobserve(lastItemRef.current);
                }
            });
            observer.observe(lastItemRef.current);
            return function() {
                if (lastItemRef.current) observer.unobserve(lastItemRef.current);
            };
        }
    }, [
        listToRender === null || listToRender === void 0 ? void 0 : listToRender.length
    ]);
    return [
        lastItemRef,
        showAllItemsRendered,
        listToRender,
        realCountToShow
    ];
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductCardRenderer/index.tsx










var FeatureProductCards = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(437), __webpack_require__.e(4505), __webpack_require__.e(2755), __webpack_require__.e(3790), __webpack_require__.e(2551)]).then(__webpack_require__.bind(__webpack_require__, 9591)).then(function(mod) {
        return mod.FeatureProductCards;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9591)
            ];
        }
    }
});
var CardFrameForCollection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5047)]).then(__webpack_require__.bind(__webpack_require__, 75047)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75047)
            ];
        }
    }
});
function ProductCardRenderer() {
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var _state = data.state, isMobile = _state.isMobile, listPresentationConfig = _state.listPresentationConfig, cardFrameConfig = _state.cardFrameConfig, contentTypeConditions = _state.contentTypeConditions;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, oneGridCellGeometry = _generalValues.oneGridCellGeometry, sectionColors = _generalValues.sectionColors, containerTracks = _generalValues.containerTracks;
    var onListItemClick = useHandleClicks().onListItemClick;
    var isProductCardEnabled = (0,ProductListWrapper_utils/* useProductCardElements */.S3)().isProductCardEnabled;
    var ref = (0,_sliced_to_array/* default */.Z)(useLastElementObservable(), 4), lastItemRef = ref[0], showAllItemsRendered = ref[1], listToRender = ref[2], realCountToShow = ref[3];
    if (!(listToRender === null || listToRender === void 0 ? void 0 : listToRender.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderCardSkeleton, {
            numberOfSkeletons: containerTracks.numColumns
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            listToRender.map(function(data, index, itemsRendered) {
                var showLastItemRef = index === (itemsRendered === null || itemsRendered === void 0 ? void 0 : itemsRendered.length) - 1 && !showAllItemsRendered;
                var ObservableElement = showLastItemRef ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: lastItemRef
                }) : null;
                if (contentTypeConditions.featuredCollection || contentTypeConditions.featuredTag || contentTypeConditions.featuredCategory) {
                    var textColorOverride = (0,utils/* getRenderCardOverrides */.JG)({
                        listPresentationConfig: listPresentationConfig,
                        sectionColors: sectionColors
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureProductCards, {
                                isProductCardEnabled: isProductCardEnabled,
                                data: data,
                                index: index,
                                oneGridCellGeometry: oneGridCellGeometry,
                                isMobile: isMobile,
                                sectionColorsOverrides: {
                                    textColor: textColorOverride
                                },
                                customClass: "!tw-h-auto !tw-w-min"
                            }, index),
                            ObservableElement
                        ]
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFrameForCollection, {
                            itemConfig: data,
                            itemIndex: index,
                            containerTracks: containerTracks,
                            cardFrameConfig: cardFrameConfig,
                            oneGridCellGeometry: oneGridCellGeometry,
                            openInNewTab: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.openInNewTab,
                            isMobile: isMobile,
                            onCollectionClick: onListItemClick,
                            contentTypeConditions: contentTypeConditions
                        }, index),
                        ObservableElement
                    ]
                });
            }),
            !showAllItemsRendered && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderCardSkeleton, {
                numberOfSkeletons: realCountToShow - (listToRender === null || listToRender === void 0 ? void 0 : listToRender.length)
            })
        ]
    });
}


/***/ }),

/***/ 80058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useItemClick; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
;// CONCATENATED MODULE: ./src/utils/storeProductClickedDetails.js

function storeProductClickedDetails() {
    var expiresAt = new Date(new Date().getTime() + 30000);
    var sessionObject = {
        expiresAt: expiresAt,
        itemClickedData: {
            CLICKED_ITEM_X_OFFSET: scrollX,
            CLICKED_ITEM_Y_OFFSET: scrollY
        }
    };
    sessionStorage.setItem(constants/* CLICKED_ITEM_OBJ */.uI, JSON.stringify(sessionObject));
}

// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(13051);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(36913);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(40190);
// EXTERNAL MODULE: ./src/utils/isStoreB2B.js
var isStoreB2B = __webpack_require__(43935);
;// CONCATENATED MODULE: ./src/hooks/useItemClick.js










function useItemClick() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var getProductRoute = function(product) {
        var ref;
        var productUrl = product === null || product === void 0 ? void 0 : product.link;
        var productRoute = (0,routes.getRoute)((0,productUtils/* getProductPathFromUrl */.ts)(productUrl, false), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        return productRoute;
    };
    /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */ var onItemClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var e, openInNewTab, ref, getRoute, productRoute, paramStr, productRouteWithParam;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, openInNewTab = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        storeProductClickedDetails();
                        e && (e === null || e === void 0 ? void 0 : e.stopPropagation());
                        sessionStorage.setItem(constants/* CLICKED_ITEM_X_OFFSET */.AB, scrollX);
                        sessionStorage.setItem(constants/* CLICKED_ITEM_Y_OFFSET */.WR, scrollY);
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 40190)).then(function(module) {
                                return module.getRoute;
                            })
                        ];
                    case 1:
                        getRoute = _state.sent();
                        return [
                            4,
                            getProductRoute(item, getRoute)
                        ];
                    case 2:
                        productRoute = _state.sent();
                        /** if color is there push with color in query params */ if (item === null || item === void 0 ? void 0 : item.color) {
                            paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
                            productRouteWithParam = productRoute + paramStr;
                            window.location.href = productRouteWithParam;
                        } else if (!(0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) && !(0,isStoreB2B/* isB2BStore */.h)()) {
                            dispatch((0,catalog/* savePDPData */.zP)({
                                visible: true,
                                product: item
                            }));
                        } else {
                            openInNewTab ? window.open(productRoute, "_blank") : window.location.href = productRoute;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onItemClick(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var getLink = function(item, getRoute) {
        var ref;
        if (!item) {
            return;
        }
        var productRoute = getProductRoute(item, getRoute);
        var productLink = "";
        if (item === null || item === void 0 ? void 0 : item.color) {
            var paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
            productLink = productRoute + paramStr;
        } else if ((0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            productLink = productRoute;
        }
        return productLink || "";
    };
    return [
        onItemClick,
        getLink
    ];
}


/***/ }),

/***/ 13051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ canShowPDPSystem; }
/* harmony export */ });
var canShowPDPSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 4134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67936);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);



var eventLogger = function(eventName) {
    var additionalData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, showInConsole = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var userData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.data;
    var eventData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        phone: (userData === null || userData === void 0 ? void 0 : userData.phone) || "",
        email: (userData === null || userData === void 0 ? void 0 : userData.email) || ""
    }, additionalData);
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .pushEventsLog */ .U)({
        event_name: eventName,
        data: eventData
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (eventLogger);


/***/ })

}]);